import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of, timeout } from 'rxjs';
import { SingletonState, SingletonStateEmptyData, SingletonsStateService } from '@bn/dashboard-shared/services';

export const singletonsResolver: ResolveFn<SingletonState> = () => {
  return inject(SingletonsStateService)
    .handleSingletonsLoad()
    .pipe(
      timeout(30_000),
      catchError(() => of(SingletonStateEmptyData)),
    );
};
